











































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    props: {
        title: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required:false,
            default: ""
        },
        type: {
            type: String,
            required:false,
            default: ""
        },
        href: {
            type: String,
            required:false,
            default: "#"
        },
        isTargetBlank: {
            type: Boolean,
            required:false,
            default: false
        },
        login: {
            type: Boolean,
            required:false,
            default: false
        },
        route: {
            type: String,
            required: false,
            default: ""
        },
        isMobile: {
            type: Boolean,
            default: true
        }
    },

    data: function() {
        return {
            open: false as boolean,
            id: uuidv4() as string,
            targetBlankString: "" as string,
            noopenerNoreferrerString: "" as string,
        };
    },

    computed: {},

    mounted: function() {
        if (this.isTargetBlank) {
            this.targetBlankString = "_blank";
            this.noopenerNoreferrerString = "noopener noreferrer nofollow";
        }

        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("to-desktop", () => {
            this.handleTabletToDesktopChange();
        }, () => {
            this.handleTabletToDesktopChange();
        });
    },

    methods: {
        toggleItem: function(e: Event) {
            // If there is a slot
            // Handle the link as a submenu button (toggle submenu)
            // If not do nothing special (follow the default link behavior)
            if (this.$slots.default) {
                e.preventDefault();

                if (this.open === true) {
                    this.closeItem();
                } else {
                    this.openItem();
                }
            }

            if(this.route !== "" && this.$router.currentRoute.name !== this.route) {
                let urlTranslated = this.$t(this.route) as string;
                const to = this.$router.resolve({path: urlTranslated});
                this.$router.push(to.location);
            }
        },
        handleEscPress: function(event: Event) {
            if (this.open === true) {
                event.stopPropagation();
                this.closeItem();
            }
        },
        openItem: function() {
            this.open = true;
            // Pass current submenu name to parent
            this.$emit("toggleSubmenu", this.name);
        },
        closeItem: function(emit = true) {
            this.open = false;

            if (emit === true) {
                // Reset current submenu opened to parent
                this.$emit("toggleSubmenu", null);
            }
        },
        handleTabletToDesktopChange: function() {
            if (this.open === true) {
                this.closeItem();
            }
        }
    }
});
